import * as React from 'react';
import {styled} from '@packages/utilities/styled';
import tooltipTrigger, {controlledTooltipTrigger} from './logic/tooltipTrigger';
import TooltipBase, {type PlacementType} from './TooltipBase';
import {pixel} from '@packages/utilities/inline-style-utils';

const variants = {
  // @ts-expect-error - TS7031 - Binding element 'theme' implicitly has an 'any' type.
  primary: ({theme}) => ({
    backgroundColor: theme.colors.accentBackground,
  }),
  // @ts-expect-error - TS7031 - Binding element 'theme' implicitly has an 'any' type.
  success: ({theme}) => ({
    backgroundColor: theme.colors.successBackground,
    color: theme.tooltip.statefulTextColor,
  }),
  // @ts-expect-error - TS7031 - Binding element 'theme' implicitly has an 'any' type.
  warning: ({theme}) => ({
    backgroundColor: theme.colors.warningBackground,
    color: theme.tooltip.statefulTextColor,
  }),
  // @ts-expect-error - TS7031 - Binding element 'theme' implicitly has an 'any' type.
  error: ({theme}) => ({
    backgroundColor: theme.tooltip.error.backgroundColor,
    color: theme.tooltip.statefulTextColor,
  }),
  // @ts-expect-error - TS7031 - Binding element 'tooltip' implicitly has an 'any' type.
  alternate: ({theme: {tooltip}}) => ({
    backgroundColor: tooltip.alternateBackgroundColor,
    color: tooltip.alternateColor,
  }),
  // @ts-expect-error - TS7031 - Binding element 'typography' implicitly has an 'any' type.
  copy: ({theme: {typography}}) => ({
    ...typography.copy,
    lineHeight: pixel(typography.copy.lineHeight),
  }),
  panel: ({
    theme: {
      // @ts-expect-error - TS7031 - Binding element 'base' implicitly has an 'any' type.
      gutters: {base},
    },
  }) => ({
    width: base * 56,
    paddingTop: base * 2,
    paddingBottom: base * 2,
    paddingLeft: base * 3,
    paddingRight: base * 3,
  }),
  consistentWithOptionSetInput: ({
    theme: {
      // @ts-expect-error - TS7031 - Binding element 'base' implicitly has an 'any' type.
      gutters: {base},
    },
  }) => ({
    padding: undefined,
    paddingTop: base,
    paddingBottom: base,
    paddingLeft: base,
    paddingRight: base,
  }),
} as const;

const StyledTooltip = styled(TooltipBase)(
  ({theme}) => ({
    backgroundColor: theme.colors.backgroundDeepest,
    color: theme.tooltip.textColor,
  }),
  variants
);

/**
 * @deprecated use `Tooltip` from `@packages/systems/spring` instead
 */
export const ToolTipBase: React.ComponentType<{
  placement: PlacementType;
  primary?: boolean;
  success?: boolean;
  warning?: boolean;
  error?: boolean;
  alternate?: boolean;
  copy?: boolean;
  panel?: boolean;
  consistentWithOptionSetInput?: boolean;
  hideOnClick?: boolean;
}> = ({placement = 'top', ...props}) => (
  // @ts-expect-error - error TS2739 - Type '{ primary?: boolean | undefined; success?: boolean | undefined; warning?: boolean | undefined; error?: boolean | undefined; alterna...
  <StyledTooltip placement={placement} {...props} />
);

/**
 * @deprecated use `Tooltip` from `@packages/systems/spring` instead
 */
export default tooltipTrigger({
  delay: 600,
})(ToolTipBase);

/**
 * @deprecated use `Tooltip` from `@packages/systems/spring` instead
 */
export const KeepToolTipTrigger = tooltipTrigger({
  hideOnClick: false,
  delay: 600,
})(ToolTipBase);

/**
 * @deprecated use `Tooltip` from `@packages/systems/spring` instead
 */
export const ControlledTooltipTrigger = controlledTooltipTrigger(ToolTipBase);
